import { render, staticRenderFns } from "./avaliacao.vue?vue&type=template&id=6b3cdeff&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./avaliacao.vue?vue&type=script&lang=js"
export * from "./avaliacao.vue?vue&type=script&lang=js"
import style0 from "./avaliacao.vue?vue&type=style&index=0&id=6b3cdeff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports